import React from "react";
import { Col, Row } from "react-bootstrap";
var toTitleCase = function (title) {
    return title
        .toLowerCase()
        .split(" ")
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(" ");
};
var LeadData = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement(React.Fragment, null,
        React.createElement(Col, { className: "bg_aqua_white" },
            React.createElement(Row, { className: "DMSan_16_700 txt-midnight-blue m-0 d-flex justify-content-center" },
                React.createElement("span", { className: "text-center" },
                    toTitleCase(props.title),
                    " :",
                    " ",
                    ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length) > 0
                        ? (_b = props.data) === null || _b === void 0 ? void 0 : _b.map(function (bk) { return bk.count; }).reduce(function (a, b) { return a + b; })
                        : 0)),
            React.createElement("div", { className: "m-0 DMSanN_14_400 txt-midnight-blue lead-values d-flex align-items-center justify-content-center" }, ((_c = props.data) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
                ((_d = props.data) === null || _d === void 0 ? void 0 : _d.map(function (bucket, id) {
                    return (React.createElement("div", { key: id },
                        bucket.bucketName,
                        " : ",
                        bucket.count));
                }))))));
};
export default LeadData;
